import { INVOICE_CONTROL_STATUS } from '../constants';

export const getLineGapFromAnalysisData = (invoiceControlDetails) => {
  const detailsWithTotalGap = invoiceControlDetails.filter(({ status, totalGap }) => {
    const isInvoiceControlLine = status !== INVOICE_CONTROL_STATUS.NO_CORRESPONDING_INVOICE_CONTROL;

    return isInvoiceControlLine && totalGap != null;
  });

  if (!detailsWithTotalGap.length) {
    return null;
  }

  return detailsWithTotalGap.reduce((total, { totalGap }) => total + totalGap, 0);
};

export const getLineGapsByInvoiceControlListId = (invoiceControlDetails, invoiceControlListIds) =>
  invoiceControlListIds.reduce((result, invoiceControlListId) => {
    const invoiceControlDetailsForList = invoiceControlDetails.filter(
      (detail) => detail.invoiceControlListId === invoiceControlListId,
    );

    result[invoiceControlListId] = getLineGapFromAnalysisData(invoiceControlDetailsForList);

    return result;
  }, {});
